/**
 * Sliding filter menu on /search page for small screens
 */

/*jshint strict:false */
/*global $ */
var SlideMenu = (function () {
    return {
        open: function () {
            var results = $('#search-results');
            $('#facets')
                .addClass('facets-open')
                .css('top', results.position().y + 'px')
                .css('left', '0');
        },
        close: function () {
            $('#facets')
                .removeClass('facets-open')
                .css('left', '').css('height', '');
        },
        toggle: function () {
            var facets = $('#facets');
            if (facets.hasClass('facets-open')) {
                facets.removeClass('facets-open')
                    .css('left', '').css('height', '');
            } else {
                facets.addClass('facets-open')
                    .css('top', $('#search-results').position().y + 'px')
                    .css('left', '0');
            }
        }
    };

}());